import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import './GamesPage.css';
import './LostJewelGamePage.css';
import {lodgeBuildReady} from './lodgeBuild';

export default function LodgeGamePage() {
    const [mobileLaunch] = useState(() => window.matchMedia('(max-width:760px), (pointer:coarse)').matches);
    useEffect(() => {
        if (mobileLaunch && lodgeBuildReady) {
            // A top-level game avoids mobile Safari iframe sizing and WebGL memory issues.
            window.location.replace('/lodge-game/index.html?v=mobile-fullscreen-2');
        }
    }, [mobileLaunch]);
    if (mobileLaunch && lodgeBuildReady) return <main className="lodge-mobile-launch" aria-live="polite">
        <h1>Opening The Lodge…</h1>
        <p>The game opens in its own full-screen page.</p>
        <a href="/lodge-game/index.html?v=mobile-fullscreen-2">Open game</a>
        <Link to="/games">Back to Games</Link>
    </main>;
    return <main className="lost-jewel-page lodge-game-page">
        <div className="lost-jewel-preview-banner"><div><strong>The Lodge — game in development</strong>
            <span>A point-and-click adventure in ceremonial preparation.</span></div><Link to="/games">← Games</Link></div>
        {lodgeBuildReady ? <iframe className="lost-jewel-frame" src="/lodge-game/index.html" title="The Lodge game preview" allow="autoplay; fullscreen" allowFullScreen/>
            : <section className="archive-game-pending"><img src="/images/the-lodge.svg" alt="The Lodge"/>
                <h1>The Lodge</h1><p>The web preview is being prepared. The Director of Ceremonies is checking every chair twice.</p>
                <Link className="archive-game-play" to="/games">Back to Games</Link></section>}
    </main>;
}
